export default __webpack_public_path__ + "static/media/openscience_funding_de.b6b5d8c4.png";